import { createTheme } from '@mui/material/styles';

import { primaryButtonColor } from './_palette';

export const theme = createTheme({
	palette: {
		primary: {
			main: primaryButtonColor,
		},
	},
	typography: {
		fontFamily: 'Lato, Roboto, Helvetica, Arial, sans-serif',
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: '8px',
				},
			},
		},
	},
});
